// © Microsoft Corporation. All rights reserved.

import { OutlineButton } from "@microsoft/fast-components-react-msft";
import React from "react";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialProps } from "../../Social.props";
import { placeholderImages } from "../../utils/images";

interface UGContentListProps extends SocialProps {
    managedClasses?: SocialClassNameContract;
    isDraft?: boolean;
}

interface UGContentListState {
    isFetchingContents: boolean;
}

export default class UGContentList extends React.Component<UGContentListProps, UGContentListState> {

    constructor(props) {
        super(props);
        this.state = {
            isFetchingContents: false
        };
    }

    editContent(id) {
        this.props.ugContentConnector.fetchUGContent(id);
        this.props.popupConnector.closePopup();
    }

    async componentDidMount() {
        this.setState({isFetchingContents: true});
        await this.props.ugContentConnector.fetchUGContents(this.props.me.id);
        this.setState({isFetchingContents: false});
    }

    extractContents() {
        if (!(this.props.users && this.props.users[this.props.me.id] && this.props.users[this.props.me.id].data.ugContents)) { return; }

        return this.props.users[this.props.me.id].data.ugContents.list.
            filter(item => this.props.isDraft ? !item.isPublished : item.isPublished);
    }

    render() {
        const { managedClasses, isDraft, t } = this.props;
        const contents = this.extractContents();

        return (
            <div className={managedClasses.ugContentListContainer}>
                <header className="cwt-ug-content-list-header">
                    <h3>{isDraft ? `${t.UGContentCreatePageMyDraft}` : `${t.UGContentCreatePageMyArticles}`}</h3>
                </header>
                <ul className="cwt-ug-content-list">
                    { contents &&
            contents.map(content =>
                <li key={content.id} className="cwt-content-info">
                    <img alt="Content thumbnail" className="cwt-content-image" src={placeholderImages.content} />
                    <div className="cwt-ug-content-details">
                        <a className="cwt-link cwt-content-title no-select">{content.title}</a>
                        <span className="cwt-datetime">{content.lastEditedDateTime}</span>
                    </div>
                    <div className="cwt-buttons">
                        <OutlineButton className="cwt-fast-button" onClick={this.editContent.bind(this, content.id)}> {t.UGContentListEditButton} </OutlineButton>
                    </div>
                </li>
            )
                    }

                    {!contents && (this.state.isFetchingContents ? `${t.UGContentListLoading}` : `${t.UGContentListNoArticles}`)}
                </ul>
            </div>
        );
    }
}
